import React from "react";
export default function Footer() {
    return (
            <nav id="footer">
                <li>
                &#xA9; Footer of a todo-ist!
                </li>
            </nav>
    )
}
